export default __webpack_public_path__ + "static/media/headerIcon.81598fc6.svg";